export default __webpack_public_path__ + "static/char-s-39-ko-a0fce45857e5a3e216a08249c89fe731.webp";